import React from "react";
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query'

import { useDebounce } from 'use-debounce';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 4
    },
  },
})
import SnapshotApp from './components/tide-predictions'


const App = ({ bid, settings }) => {


  return (
    <QueryClientProvider client={queryClient}>
      <SnapshotApp bid={bid} {...settings} />
    </QueryClientProvider>
  )
}


const app = document.querySelector('.linz-map-snapshot__tp');


if(app) {

  const settings = drupalSettings.linz_map_snapshot_tp;
  const root = createRoot(app)

  root.render(<App settings={settings} />)
}
